import router from "@router";
import { getRoute } from "@environment/type";
import { Language } from "@/language/index.js";
import { customAlert } from "@/common/commonMethod.js";

export const routerPush = params => {
  const { path, query, isParams } = params;
  //console.log(params);
  let newQuery = {};
  query.forEach(item => {
    newQuery[item.name] = item.value;
  });
  //console.log(newQuery);
  if (isParams === true) {
    router.push({
      path: "/" + path,
      query: newQuery
    });
  } else {
    router.push({
      path: "/" + path
    });
  }
};

export const routerReplace = params => {
  const { path, query, isParams } = params;
  //console.log(params);
  let newQuery = {};
  query.forEach(item => {
    newQuery[item.name] = item.value;
  });
  //console.log(newQuery);
  if (isParams === true) {
    router.replace({
      path: "/" + path,
      query: newQuery
    });
  } else {
    router.replace({
      path: "/" + path
    });
  }
};

// 返回上一路由
export const pop = () => {
  //console.log("执行pop");
  router.go(-1);
};

// 返回首页
export const backHome = () => {
  //console.log("执行backHome");
  router.push({
    path: getRoute() + "home"
  });
};

// 返回用户中心
export const backUser = () => {
  //console.log("执行backUser");
  router.push({
    path: getRoute() + "user/userManage"
  });
};

export default {
  routerPush,
  routerReplace,
  pop,
  backHome,
  backUser
};
